import Image from "next/image";
import { isNil } from "@/common/helpers/lang";

import { getBulletListClass, getListClass, getListItemClass } from "./bullet-list.styles";
import type { BulletListProps } from "./bullet-list.types";

export function BulletList({ className, heading, subheading, items, ...props }: BulletListProps) {
  return (
    <div className={getBulletListClass({ className })} {...props}>
      {isNil(heading) ? null : <h5 className="font-bold text-lg lg:text-2xl">{heading}</h5>}
      {isNil(subheading) ? null : <p className="mt-2 text-gray-800 lg:mt-4 lg:text-xl">{subheading}</p>}
      <div className="flex flex-col pt-3 lg:flex-row lg:gap-2 lg:pt-5">
        <ul className={getListClass()}>
          {items
            .filter((_, index) => index % 2 === 0)
            .map((item) => (
              <li key={item} className={getListItemClass()}>
                <div className="flex size-6 shrink-0 items-center justify-center pt-1">
                  <Image src="/next-assets/common/bullet-list-item-sign.svg" alt="bullet" width={12} height={12} />
                </div>
                <span>{item}</span>
              </li>
            ))}
        </ul>
        <ul className={getListClass()}>
          {items
            .filter((_, index) => index % 2 !== 0)
            .map((item) => (
              <li key={item} className={getListItemClass()}>
                <div className="flex size-6 shrink-0 items-center justify-center pt-1">
                  <Image src="/next-assets/common/bullet-list-item-sign.svg" alt="bullet" width={12} height={12} />
                </div>
                <span>{item}</span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
